import { SendRegular } from '@fluentui/react-icons';
export const deliveriesModule = {
    path: 'disparos',
    title: 'Disparos',
    icon: SendRegular,
    placement: 'main',
    pages: [
        {
            path: 'historico',
            title: 'Disparos',
            description: 'Tudo o que o bot enviou: quando, para quem, as tentativas e a mensagem.',
            icon: SendRegular,
            permission: 'Deliveries.Read',
            load: () => import('#src/modules/deliveries/DeliveriesPage.js').then((m) => m.DeliveriesPage),
        },
    ],
};
//# sourceMappingURL=deliveries.module.js.map